export default __webpack_public_path__ + "static/media/logo.10bf8cb1.svg";